var image_viewer_rtlignore_default = {
  "fontElementMap": "cdGHG",
  "imageContainer": "CS3QH",
  "expandButton": "yWJuZ",
  "expandIcon": "_0sBft",
  "pointer": "JZY--",
  "imageWrapper": "Yj--e",
  "imageRatio": "TiDTH",
  "image": "u68QN",
  "imageOverlay": "BIwaY",
  "imagePreload": "u8hXz",
  "imageHighres": "YjPt0",
  "onlyHighRes": "tBKsK",
  "image_loading": "uD4u5"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
